import React from "react";
import "../styles/Footer.css";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* About Us */}
        <div className="footer-column">
          <h3>About Qibla</h3>
          <p>
            Qibla is committed to revitilizing Islamic education by integrating traditional values
            with modern pedagogical practices.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#need">The Need</a></li>
            <li><a href="#approach">Approach</a></li>
            <li><a href="#courses">Free Courses</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-column">
          <h3>Contact Us</h3>
          <p>Email: <a href="mailto:m2aslam@gmail.com">m2aslam@gmail.com</a></p>
          <p>Phone: +92 300 8427 613</p>
          <p>Address: 123 Qibla Avenue, Knowledge City</p>
          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>&copy; 2025 Qibla Platform. All Rights Reserved.</p>
        <a href="#top" className="back-to-top">Back to Top</a>
      </div>
    </footer>
  );
};

export default Footer;
